import * as preact from 'preact'
const { h, Component } = preact
import { Foreground } from '../foreground'
import { Background } from '../background'
import { Section as SectionProps } from '../types'
import PureComponent from '../../lib/preact-pure-component'
import style from './style.css'

interface Props {
  addIntersectionElement: (el: HTMLElement) => void
  section: SectionProps
  active: boolean
  preload: boolean
  backgroundFadeUpDelay?: boolean
}

export class Section extends PureComponent<Props, {}> {
  render() {
    const { section, addIntersectionElement, active, preload, backgroundFadeUpDelay } = this.props
    return (
      <div className={style.wrapper}>
        <Background
          fadeUpDelay={backgroundFadeUpDelay}
          preload={preload}
          active={active}
          section={section}
          {...this.props}
        />
        <Foreground
          noShadow={section.type === 'black'}
          addIntersectionElement={addIntersectionElement}
          id={`${this.props.section.id}-${0}`}
          active={active}
          preload={preload}
          blocks={section.blocks}
          type={section.type}
          style={section.style}
          align={section.props ? section.props.align : undefined}
          shadowColor={section.props ? section.props.shadowColor : undefined}
        />
      </div>
    )
  }
}
